module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av3-0ebaf3a19718093def27cc8758958f4a.jpg";